import { useState } from "react";
import useAxios from "./useAxios";
import { message } from "antd";

const useGet = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [data, setData] = useState<any>();
  const { get } = useAxios();

  const loadData = ({
    api,
    isExternal,
    params,
    method,
    id,
    replace = true,
    token,
    successText,
    onSuccess,
  }: {
    api?: any;
    isExternal?: any;
    params?: any;
    method?: any;
    id?: any;
    replace?: any;
    token?: any;
    successText?: any;
    onSuccess?: any;
  }) => {
    if (replace) setData(null);
    setSuccess(false);
    setLoading(true);
    // If id is passed get single instance, other fetch list
    get({
      api: id ? `${api}${id}/` : api,
      params,
      isExternal,
      loader: setLoading,
      errorHandler: setError,
      successHandler: (data: any) => {
        setData(data);
        setSuccess(true);
        if (successText) {
          message.success(successText);
        }
        onSuccess && onSuccess(data);
      },
      methodName: method,
      token,
    });
  };

  return { loading, error, data, success, loadData, setLoading };
};

export default useGet;
